// @flow
import { INSTAGRAM } from 'Client/cms/toolkit/constants';
import { InstagramLine } from 'Components/lines/instagram-line/InstagramLine';
import { instagramResolver } from './instagram.resolver';

export const instagramDescriptor = {
  name: INSTAGRAM,
  component: InstagramLine,
  resolver: instagramResolver.resolve,
};
